export const  MODIFY_LIST = {
    2: '未整改',
    1: '已整改',
    0: '全部',
}
